module.exports = "<span ng-bind=$ctrl.dayShift></span>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/atc/atc-flights-view/flight-recommendation/flight-segment/flight-group/flight-group-days-shift-arrival/flight-group-days-shift-arrival.html
// module id = 3650
// module chunks = 0